import { ConfigProvider, DatePicker } from "antd";
import React, { useState } from "react";
import locale from "antd/lib/locale/fa_IR";
import {
  DatePicker as DatePickerJalali,
} from "antd-jalali";
import dayjs from "dayjs";
import jMoment from "moment-jalaali"
import PersianDatePicker from "../../Events/NewRangePicker"

const HomePageDatePicker = ({ setDateHOC, dateHOC }) => {

  const [date, setDate] = useState(dateHOC);
  // console.log(dateHOC , date , "is date");

  const checkDateValidate = (d) => {
    if (d === NaN || d === null || d === undefined) {
      return dayjs(new Date(), { jalali: true })
    } else {
      return d
    }
  }

  return (
    <div>
      {/* <DatePickerJalali
        key="dashboard-daily-chart-datepicker"
        defaultValue={checkDateValidate(date)}
        value={checkDateValidate(date)}
        onChange={(date, dateString) => {
          // console.log(dayjs(date, { jalali: true }), dateString)
          setDateHOC(dayjs(date, { jalali: true }));
          setDate(checkDateValidate(dayjs(date, { jalali: true })));
        }}

      /> */}

      <PersianDatePicker dateHOC={date} onChange={date => {
        console.log(date, jMoment(date, "jYYYY-jMM-jDD").format("YYYY-MM-DD") , "is date")
        setDateHOC(date);
        setDate(date)
      }}/>
    </div>

  );
};

export default React.memo(HomePageDatePicker);
